import { render, staticRenderFns } from "./PageHome.vue?vue&type=template&id=22299846&"
import script from "./PageHome.vue?vue&type=script&lang=js&"
export * from "./PageHome.vue?vue&type=script&lang=js&"
import style0 from "./PageHome.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports